import { Component } from '@angular/core';

@Component({
  selector: 'app-stabsbillett-betaling',
  templateUrl: './stabsbillett-betaling.component.html',
  styleUrls: ['./stabsbillett-betaling.component.scss']
})

export class StabsbillettBetalingComponent {}
